import { useContext } from "react";
import AccordionNewUI from "../../../../components/common/v2/AccordionNewUI";
import { LoansContext } from "../../../../context/LoansContext";
import DocumentList from "./DocumentList";
import FileUpload from "./FileUpload";
import { buildChecklistPayload } from "../../../../utils/requiredDocuments";
import { DOCUMENTS_SECTION_ID } from "./MissingDocumentsDialog";
import RequiredDocuments from "./RequiredDocuments";

export default function Documents(props: any) {
  const {
    loanDetails,
    detailedLoanSizingData,
  } = useContext(LoansContext);

  const { isApplicationSubmitted, uploadDocument, setDocumentList, documentList } = props;
  const getChecklistPayload = (docs: any[]) =>
    buildChecklistPayload(
      props?.dynamicConfig?.requiredDocuments,
      detailedLoanSizingData?.loanInformation,
      docs,
    );
  const isLoanSubmitted = Boolean(loanDetails?.tcLoanId);
  const renderLoanDetailsUI = () => {
    return (
      <div style={{ marginBottom: "16px" }}>
        <FileUpload uploadDocument={uploadDocument} loanDetails={loanDetails}/>
        <div style={{ display: "flex", gap: "8px", alignItems: "stretch" }}>
          <RequiredDocuments
            checklist={loanDetails?.documentChecklist}
            uploadDocument={uploadDocument}
            dynamicConfig={props?.dynamicConfig}
            isLoanSubmitted={isLoanSubmitted}
            setDocumentList={setDocumentList}
            documentList={documentList}
            getChecklistPayload={getChecklistPayload}
          />
          <DocumentList documents={loanDetails.documents} dynamicConfig={props?.dynamicConfig} isLoanSubmitted={isLoanSubmitted} setDocumentList={setDocumentList} documentList={documentList} getChecklistPayload={getChecklistPayload}/>
        </div>
      </div>
    );
  };

  return (
    <div id={DOCUMENTS_SECTION_ID}>
      <AccordionNewUI
        label={"Documents"}
        isApplicationSubmitted={isApplicationSubmitted}
        renderUI={renderLoanDetailsUI}
      />
    </div>
  );
}
